export default "__VITE_ASSET__B8YItIf2__"